import { render } from "./balance-card.vue?vue&type=template&id=1266281e"
import script from "./balance-card.vue?vue&type=script&lang=js"
export * from "./balance-card.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__